export default "__VITE_PUBLIC_ASSET__23e5f41c__"